import { useNavigate } from "react-router";
import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import NewUtmifyForm from "../../../components/apps/utmify/NewUtmifyForm";

export default function NewUtmify() {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(`/apps/utmify`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Nova Integração UTMify"
                description="Criar nova integração UTMify"
            />
            <PageBreadcrumb
                pageTitle="Nova Integração UTMify"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <NewUtmifyForm
                    onSuccess={() => {
                        navigate(`/apps/utmify`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao criar integração UTMify:", error);
                    }}
                />
            </div>
        </>
    );
}
